export const TenantClientSelector = {
  mounted() {
    this.handleEvent('close_dropdown', () => {
      this.el.style.display = 'none';
      this.el.setAttribute('aria-hidden', 'true');
    });
  }
};
